import { Attachment, domain } from "@relode/core";
import {
    convertFileResponse,
    FileResponse,
} from "@relode/core/backend/responses";
import { Stakeholder, Tag, UserRole } from "@relode/core/domain";

import { JobManagerContact, Location, TagMatch, TagType } from "../../types";
import {
    JobManagerContactResponse,
    JobPositionResponse,
    LocationResponse,
    TagMatchResponse,
    TagResponse,
} from "../shared";

export const convertLocationResponse = (
    response: LocationResponse
): Location => {
    if (!response) return null;

    const location: Location = new Location();
    location.locationId = response.locationId;
    location.locationName = response.locationName;
    location.postalCode = response.postalCode;
    return location;
};

export const convertTagMatchResponseList = (
    response: TagMatchResponse[]
): TagMatch[] =>
    response
        .filter(t => t !== undefined && t !== null)
        .map(t => convertTagMatchResponse(t));

export const convertTagMatchResponse = (
    response: TagMatchResponse
): TagMatch => {
    if (!response) return null;

    const tag = new TagMatch();
    tag.tagId = response.tagId;
    tag.tagName = response.tagName;
    tag.tagTypeId = response.tagTypeId;
    tag.isMatched = response.isMatched;
    return tag;
};

export const convertTagResponse = (response: TagResponse): Tag => {
    if (!response) return null;

    const tag = new Tag(
        response.tagId,
        response.tagName,
        response.tagTypeId,
        response.tagTypeName
    );
    return tag;
};

export const convertTagTypeResponse = (response: TagResponse): TagType => {
    if (!response) return null;

    const tag = new TagType();
    tag.tagId = response.tagId;
    tag.tagName = response.tagName;
    tag.tagTypeId = response.tagTypeId;
    tag.tagTypeName = response.tagTypeName;
    return tag;
};

export const convertTagTypeResponseList = (
    response: TagResponse[]
): TagType[] => {
    if (!response) return null;

    return response
        .filter(t => t !== undefined && t !== null)
        .map(t => convertTagTypeResponse(t));
};

export const convertJobPositionResponse = (
    response: JobPositionResponse
): domain.JobPosition => {
    if (!response) return null;

    const jp: domain.JobPosition = {
        jobCategoryId: undefined,
        jobCategoryName: response.jobCategoryName,
        jobPositionId: response.jobPositionId,
        jobPositionName: response.jobPositionName,
    };
    return jp;
};

export const convertJobPositionResponseList = (
    response: JobPositionResponse[]
): domain.JobPosition[] => {
    if (!response) return null;

    return response
        .filter(jp => jp !== undefined && jp !== null)
        .map(jp => convertJobPositionResponse(jp));
};

export const convertFileResponseList = (
    response: FileResponse[]
): Attachment[] =>
    response
        ?.filter(t => t !== undefined && t !== null)
        .map(t => convertFileResponse(t));

export const convertJobManagerContactResponse = (
    response: JobManagerContactResponse
): Stakeholder => {
    if (!response) return null;

    const role = UserRole.asArray().find(r => r.roleName === response.roleName);
    const stakeholder: Stakeholder = {
        email: response.email,
        name: response.fullName,
        phoneNumber: response.phoneNumber,
        role: role,
        userId: response.userId,
    };
    return stakeholder;
};
export const convertJobManagerContactResponseNonStakeholder = (
    response: JobManagerContactResponse
): JobManagerContact => {
    if (!response) return null;

    const jobManagerContact = new JobManagerContact();
    jobManagerContact.fullName = response.fullName;
    jobManagerContact.email = response.email;
    jobManagerContact.phoneNumber = response.phoneNumber;
    jobManagerContact.profileImageUrl = response.profileImageUrl;
    jobManagerContact.userId = response.userId;
    jobManagerContact.roleName = response.roleName;
    jobManagerContact.initials = response.initials;

    return jobManagerContact;
};
